const shades = {
  _1: '#C4CAD0',
  _2: '#212121',
  _3: '#F1F2F3',
  _4: '#E7E8EF',
  _5: '#F6F7FC',
  _6: '#EAEAEA',
  _7: '#808A97', // formerly '#9DA5B0',
};

const gray = {
  50: '#F9FAFB',
  100: '#F2F3F5',
  200: '',
  300: '',
  400: '',
  500: '',
  600: '#808A97',
  700: '',
}

const primary = {
  50: '#F2F4FF',
  100: '',
  200: '',
  300: '',
  400: '',
  500: '',
  600: '#808A97',
  700: '',
}

const tintColor = '#3B54EC';
const midTintColor = '#2036BC';
const darkTintColor = '#212988';
const darkerTintColor = '#171C34';
const darkColor = '#12253F';
const whiteColor = '#FFFFFF';
const greyColor = '#ADB5BD';
const redColor = '#EE3939';
const greenColor = '#24A148';
const darkTextColor = shades._2;
const borderColor = gray[100];
const inputBorderColor = shades._6;
const levelLow = redColor;
const levelMid = '#F9B13D';
const levelHigh = greenColor;

export default {
  tintColor,
  midTintColor,
  darkTintColor,
  darkerTintColor,
  whiteColor,
  greyColor,
  darkColor,
  darkTextColor,
  borderColor,
  inputBorderColor,
  tabIconDefault: shades._1,
  tabIconSelected: tintColor,
  tabBar: shades._6,
  dangerBackground: '#EE39391A',
  dangerText: redColor,
  successBackground: '#24A1481A', // '#A8EEC1',
  successText: '#24A148', //'#197741',
  warningBackground: '#FAE29F',
  warningText: '#8C6D1F',
  inputFocused: tintColor,

  homeHeaderBg: darkTintColor,
  homeHeaderBg2: '#0E1449',
  greenColor,
  redColor,

  levelLow,
  levelMid,
  levelHigh,

  shades,
  gray,
  primary
};
